import { graphql } from "@/api/graphql/types/gql";

export const getAccountsLinkableToTidQuery = graphql(`
  query GetAccountsLinkableToTid(
    $request: BillingMsGetAccountsLinkableToTidRequest!
  ) {
    BillingMsGetAccountsLinkableToTid(request: $request) {
      data {
        accountId
        accountNumber
        accountName
      }
      pagination {
        page
        size
        total
      }
    }
  }
`);
